import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
// 声明变量
// declare const a: any;

@Component({})
export default class InfoPersonal extends Vue {
    private $api: any;
    private $cookie: any;
    private currentDate = new Date();
    private list: any = {ShowProblem : false, ShowAuditProblem : false, ShowAuditBtn : false, ShowBtn : false, IsDeptSum : false, IsNone : false, ShowNotice : false};
    // 详情信息
    private item: any = [];
    // 假期类型
    private typeArr: any = [];
    private itemId: any;

    private async mounted() {
        this.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        // 根据ID获取详情信息
        this.itemId = this.$route.query.CId ? this.$route.query.CId : JSON.parse(localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '').CId;
        const modelId = {
            id: this.itemId,
        };
        // 获取详情
        const infos = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryOneUserInfo', modelId);
        if (infos.Success) {
            if (infos.Data && infos.Data.length > 0) {
                this.list.IsNone = false;
                this.item = infos.Data[0];
                this.item.CheckMonth = moment(this.item.CheckMonth).format('YYYY-MM');
                // 获取假期类型
                const model = {
                    Msg: this.item.CheckWords,
                };
                const LeaveType = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryLeaveType', model);
                // 判断是否是部门负责人
                const TimeModel  = {
                    year: moment(this.item.CheckMonth).format('YYYY'),
                    month: moment(this.item.CheckMonth).format('M'),
                };
                const IsBtn = await this.$api.httpPost('membership/Monthlysummary/IPostBtnIsShow', TimeModel);
                this.$toast.clear();
                this.typeArr = LeaveType.Data;
                if (this.typeArr && this.typeArr.length > 0) {
                    for (const itemes of this.typeArr) {
                        itemes.Value = this.item.CheckWords[itemes.Code];
                    }
                }
                // 是否显示问题反馈内容
                if (this.item.CheckStatus === 1 || this.item.CheckStatus === 2) {
                    this.list.ShowProblem = true;
                } else {
                    this.list.ShowProblem = false;
                }
                // 是否显示上级反馈内容
                if (this.item.IsShowLeaderFeeback === true) {
                    this.list.ShowAuditProblem = true;
                } else {
                    this.list.ShowAuditProblem = false;
                }
                if (IsBtn.Success) {
                    if (IsBtn.Data) {
                        if (IsBtn.Data.IsDepartRole) {
                            this.list.IsDeptSum = true;
                        }
                        if (IsBtn.Data.IsDepartRole && (this.$cookie.get('CURLOGINNAME') !== this.item.Code)) {
                            if ((this.item.IsShowLeaderFeeback === false) && (this.item.IsArchiveShow === false)) {
                                this.list.ShowAuditBtn = true;
                            }
                            this.list.ShowBtn = false;
                        } else {
                            this.list.ShowAuditBtn = false;
                            if (IsBtn.Data.IsShowCofirm && this.item.CheckStatus === 0) {
                                this.list.ShowBtn = true;
                            } else {
                                this.list.ShowBtn = false;
                            }
                        }
                    }
                } else {
                    this.$toast.clear();
                    this.$dialog.alert({
                        title: '错误',
                        message: IsBtn.AllMessages,
                    });
                }
            } else {
                this.$toast.clear();
                this.list.IsNone = true;
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: infos.AllMessages,
            });
        }
        if (this.list.ShowBtn) {
            this.list.ShowNotice = false;
        } else {
            this.list.ShowNotice = true;
        }
    }
    // 确认部门考勤
    private sureInfo() {
        this.$dialog.confirm({
            title: '确认考勤',
            message: '点击确定，即您的本月考勤数据准确，是否确认？',
        }).then(async () => {
            const data = await this.$api.httpPost('membership/Monthlysummary/IPostMonthlysummaryconfirm');
            if (data.Success) {
                // console.log(data.Data);
                // if (data.Data) {
                //     console.log(data.Data);
                // }
            } else {
                this.$toast.clear();
                this.$dialog.alert({
                    title: '错误',
                    message: data.AllMessages,
                });
            }
            this.list.ShowBtn = false;
            this.list.ShowNotice = true;
        }).catch(() => {
            // console.log('cancel');
        });
    }
    // 跳转问题反馈页
    private async toProblem(item: any) {
        this.$router.push({ name: 'edit-problem', params: { infoId: this.itemId, index: item}});
    }
    // 跳转部门考勤列表页
    private ToManagerList() {
        this.$router.push({ name: 'monthly-list' });
    }
}
